import { ia } from 'lib/helpers/utility';

import SegmentedControl from 'components/shared/SegmentedControl/SegmentedControl';

import NewACH from './components/NewACH';
import { achOptions } from './lib/helpers';
import SavedACH from './components/SavedACH';

const PayWithAchContent = ({
  savedACHs,
  active,
  setActive,
  scrollRef,
  isFetchingNextPage,
  values,
  hideButton,
  buttonText,
  children,
  NewAchComponent,
  onError
}) => {
  const NewAch = NewAchComponent || NewACH;

  return (
    <div className="flex flex-col gap-4">
      {ia(savedACHs) && (
        <SegmentedControl
          active={active}
          items={achOptions(savedACHs)}
          onClick={(option) => setActive(option.value)}
        />
      )}
      {active === 'saved-ach' && (
        <>
          <SavedACH
            ref={scrollRef}
            savedACHs={savedACHs}
            isFetchingNextPage={isFetchingNextPage}
            hideButton={hideButton}
          />
          {children}
        </>
      )}
      {active === 'new-ach' && (
        <NewAch
          key="pay-with-new-ach"
          amount={values?.amount}
          hideButton={hideButton}
          buttonText={buttonText}
          onError={onError}
        />
      )}
    </div>
  );
};

export default PayWithAchContent;
